export const rateSheetId = {
  printButton: 'rateSheetPrintButton',
  newSearchButton: 'rateSheetNewSearchButton',
};
